// Catalogo servizi professionali OGStay — /servizi
// Ogni servizio: icon = nome icona lucide, remote = disponibile da remoto (altrimenti richiede presenza in Ogliastra)
// price/launch = listino e prezzo lancio; quote = su preventivo; offers = offerte multiple nella stessa scheda

// Immagini di supporto per le schede servizio — asset reali OGStay
const WIX = (id) =>
  `https://static.wixstatic.com/media/${id}/v1/fill/w_800,h_500,al_c,q_85,enc_auto/${id}`;
const KROSS = (p) => `https://cdn.krossbooking.com/ogstay/images/3/${p}`;

export const SERVICE_IMAGES = {
  "ottimizzazione-annunci": KROSS("12/17832466469593.webp"),
  "check-up-annuncio": KROSS("11/17825064503325.webp"),
  "pratiche-adempimenti": KROSS("11/17825064473453.webp"),
  "consulenza-1to1": WIX("862de4_b1b2df7701b64de99bf514cb0d936682~mv2.png"),
  "revenue-management": WIX("862de4_c764b4534d30499ab8ed2ecbbf4eb5c8~mv2.png"),
  "avvio-da-zero": "/staging-a.jpg",
  "audit-completo": WIX("862de4_7327c0aec0b14657a3ed7fac5cf1031e~mv2.png"),
  "home-staging": "/staging-b.webp",
  "fotografia": KROSS("12/17832466469096.webp"),
  "listing-makeover": KROSS("11/17825064459037.webp"),
};
export const CATALOG = {
  it: {
    kicker: "OGStay Services",
    title: "La nostra esperienza. Al servizio della tua casa.",
    sub: "Non devi affidarci l'intera gestione per lavorare con noi. Scegli il supporto professionale che può fare la differenza per il tuo immobile.",
    launchNote: "Offerta di lancio riservata ai primi 5 clienti per ciascun servizio aderente.",
    launchSub: "Sconto indicativo del 30%, con prezzi commercialmente arrotondati.",
    listino: "Listino",
    lancio: "Lancio",
    quote: "Su preventivo",
    discover: "Scopri cosa comprende",
    close: "Chiudi dettagli",
    request: "Richiedi informazioni",
    includedLabel: "Cosa comprende",
    excludedLabel: "Non compreso",
    timingLabel: "Tempi indicativi",
    conditionsLabel: "Condizioni",
    remoteBadge: "Disponibile da remoto",
    onsiteBadge: "Presenza sul territorio",
    whatsapp: "Scrivici su WhatsApp",
    call: "Chiamaci",
    callCta: "Parliamone: 15 minuti gratuiti.",
    callCtaSub: "Una chiamata conoscitiva da concordare insieme, senza impegno.",
    waMessage: (service) => `Buongiorno OGStay, sono interessato al servizio di ${service}. Vorrei maggiori informazioni e una chiamata conoscitiva gratuita.`,
    services: [
      {
        id: "ottimizzazione-annunci",
        icon: "Megaphone",
        title: "Ottimizzazione Annunci Airbnb & Booking.com",
        tagline: "Il tuo annuncio è il tuo primo venditore. Lo rendiamo più efficace.",
        description: "Rivediamo il tuo annuncio da cima a fondo: testi, fotografie, servizi e impostazioni commerciali, per renderlo più chiaro, più convincente e più visibile.",
        price: "149 €",
        launch: "104 €",
        remote: true,
        timing: "48–72 ore lavorative dalla ricezione di tutti i materiali necessari.",
        conditions: "Prezzo riferito a un immobile e una piattaforma.",
        included: [
          "Analisi di un annuncio esistente",
          "Ottimizzazione di titolo e descrizioni",
          "Riordino strategico delle fotografie disponibili",
          "Localizzazione dei testi in italiano, inglese, francese, tedesco e spagnolo, ove supportata",
          "Revisione di servizi, dotazioni e caratteristiche",
          "Verifica delle promozioni e degli sconti",
          "Implementazione delle modifiche autorizzate",
          "Riepilogo finale",
        ],
        excluded: ["Shooting fotografico", "Revenue management", "Gestione continuativa"],
      },
      {
        id: "check-up-annuncio",
        icon: "FileSearch",
        title: "Check-up Annuncio",
        tagline: "Scopri cosa puoi migliorare, prima di investire.",
        description: "Un controllo rapido e professionale del tuo annuncio, con un report concreto sulle priorità di intervento.",
        price: "49 €",
        launch: "34 €",
        remote: true,
        timing: "48 ore lavorative.",
        included: [
          "Analisi di un annuncio",
          "Verifica di titolo, testi e immagini",
          "Controllo delle informazioni",
          "Identificazione delle criticità",
          "Report con cinque interventi prioritari",
        ],
        excluded: ["Modifiche dirette all'annuncio"],
      },
      {
        id: "pratiche-adempimenti",
        icon: "FileText",
        title: "Pratiche e Adempimenti",
        tagline: "Meno burocrazia. Più velocità nel partire.",
        description: "Ti aiutiamo a orientarti tra procedure e adempimenti grazie alla nostra esperienza operativa e alla conoscenza delle pratiche del settore.",
        price: "da 199 €",
        launch: "da 139 €",
        remote: true,
        timing: "Le tempistiche dipendono dagli enti e dalla completezza della documentazione.",
        conditions: "Le prestazioni professionali riservate non sono incluse.",
        included: [
          "Verifica preliminare delle procedure applicabili",
          "Supporto per codici identificativi",
          "Assistenza nelle procedure Alloggiati Web",
          "Indicazioni su comunicazioni statistiche e imposta di soggiorno",
          "Organizzazione documentale",
          "Checklist di avvio",
        ],
        excluded: [],
      },
      {
        id: "consulenza-1to1",
        icon: "MessagesSquare",
        title: "Consulenza Strategica 1:1",
        tagline: "Un'ora di confronto. Un piano per migliorare.",
        description: "Un'ora dedicata alla tua attività: analizziamo insieme annunci, prezzi e organizzazione e ripartiamo con un piano d'azione chiaro.",
        price: "99 €",
        launch: "69 €",
        remote: true,
        timing: "Videochiamata di 60 minuti, da concordare insieme.",
        conditions: "Questa consulenza a pagamento è distinta dalla chiamata conoscitiva gratuita di 15 minuti.",
        included: [
          "Videochiamata individuale di 60 minuti",
          "Analisi preliminare dell'esigenza",
          "Confronto su annunci, prezzi, organizzazione e gestione",
          "Raccomandazioni personalizzate",
          "Sintesi delle azioni consigliate",
        ],
        excluded: [],
      },
      {
        id: "revenue-management",
        icon: "TrendingUp",
        title: "Revenue Management",
        tagline: "Il prezzo giusto non è sempre lo stesso.",
        description: "Due modi di lavorare sui prezzi: un'impostazione strategica iniziale oppure una gestione tariffaria continuativa con un revenue manager dedicato.",
        remote: true,
        offers: [
          {
            name: "Strategia Prezzi Una Tantum",
            price: "249 €",
            launch: "174 €",
            included: [
              "Analisi di mercato e concorrenza",
              "Valutazione della stagionalità",
              "Impostazione strategica dei prezzi",
              "Indicazioni su soggiorni minimi e restrizioni",
              "Piano tariffario iniziale",
            ],
            excluded: ["Aggiornamenti continuativi"],
          },
          {
            name: "Revenue Management Continuativo",
            price: "da 60 €/mese per immobile",
            launch: null,
            launchNote: "Lo sconto lancio non si applica al canone mensile.",
            included: [
              "Strategia tariffaria continuativa",
              "Monitoraggio periodico della domanda",
              "Aggiornamento dei prezzi",
              "Analisi dell'andamento delle prenotazioni",
              "Supporto del revenue manager dedicato",
            ],
            excluded: [],
          },
        ],
        conditions: "Le inclusioni del piano continuativo sono definite in base al piano concordato.",
      },
      {
        id: "avvio-da-zero",
        icon: "KeyRound",
        title: "Avvio Casa Vacanza da Zero",
        tagline: "Dall'idea al tuo primo annuncio.",
        description: "Ti accompagniamo passo passo nella nascita della tua attività: dalla preparazione della casa al primo annuncio online.",
        price: "da 399 €",
        launch: "da 279 €",
        remote: true,
        timing: "Da concordare in base al punto di partenza.",
        conditions: "Esclusioni valide salvo accordi specifici.",
        included: [
          "Valutazione iniziale",
          "Checklist di preparazione",
          "Consigli su dotazioni e organizzazione",
          "Configurazione iniziale degli account concordati",
          "Creazione di un annuncio",
          "Impostazioni operative di base",
          "Indicazioni sulla comunicazione con gli ospiti",
          "Formazione iniziale",
        ],
        excluded: ["Pratiche amministrative", "Shooting fotografico", "Software a pagamento", "Revenue management avanzato"],
      },
      {
        id: "audit-completo",
        icon: "ClipboardCheck",
        title: "Audit Completo dell'Attività",
        tagline: "Scopri dove stai perdendo opportunità.",
        description: "Un'analisi completa della tua attività di affitto breve, con un report che indica dove intervenire prima.",
        price: "da 299 €",
        launch: "da 209 €",
        remote: true,
        timing: "Da concordare in base alla documentazione disponibile.",
        included: [
          "Analisi degli annunci",
          "Analisi dei canali di vendita",
          "Valutazione della comunicazione con gli ospiti",
          "Revisione dei processi operativi",
          "Analisi dei dati disponibili",
          "Report con priorità di intervento",
        ],
        excluded: ["Implementazione delle modifiche"],
      },
      {
        id: "home-staging",
        icon: "Sparkles",
        title: "Home Staging per Case Vacanza",
        tagline: "Non arrediamo soltanto gli ambienti. Li rendiamo più desiderabili.",
        description: "Valorizziamo la tua casa con interventi mirati, pensati per gli annunci e per gli ospiti, fino alla preparazione per il servizio fotografico.",
        quote: true,
        remote: false,
        timing: "Da definire con il sopralluogo e la proposta.",
        conditions: "Il compenso OGStay e il costo dei materiali sono distinti. Gli oggetti acquistati per il cliente restano di sua proprietà. Trasporti, montaggi o lavorazioni particolari sono preventivati separatamente.",
        included: [
          "Analisi dell'immobile",
          "Proposta di valorizzazione estetica",
          "Piano degli interventi",
          "Definizione del budget",
          "Selezione di complementi, tessili e decorazioni",
          "Acquisto dei materiali approvati dal proprietario",
          "Allestimento degli ambienti",
          "Preparazione della casa per il servizio fotografico",
        ],
        excluded: [],
      },
      {
        id: "fotografia",
        icon: "Camera",
        title: "Fotografia Professionale",
        tagline: "Le immagini giuste fanno vedere la tua casa con occhi diversi.",
        description: "Un servizio fotografico pensato per gli affitti brevi: ambienti, dettagli e punti di forza, con immagini pronte per i tuoi annunci.",
        quote: true,
        remote: false,
        timing: "Da concordare in base alla disponibilità dell'immobile.",
        conditions: "Il preventivo precisa quantità di scatti, spostamenti e diritti di utilizzo.",
        included: [
          "Pianificazione dello shooting",
          "Fotografi specializzati in case vacanza",
          "Fotografia degli ambienti e dei punti di forza",
          "Selezione e postproduzione",
          "Consegna delle immagini",
          "Indicazioni per l'utilizzo negli annunci",
        ],
        excluded: [],
      },
      {
        id: "listing-makeover",
        icon: "Palette",
        title: "OGStay Listing Makeover",
        tagline: "La trasformazione completa della tua presenza online.",
        description: "Il pacchetto integrato: valorizzazione degli ambienti, immagini professionali e annunci riscritti da zero, per ripartire con una presenza online completamente nuova.",
        quote: true,
        remote: false,
        timing: "Da definire in base agli interventi concordati.",
        conditions: "Materiali e prestazioni extra da preventivare separatamente. Revenue Management disponibile come servizio aggiuntivo.",
        included: [
          "Valutazione dell'immobile",
          "Home staging",
          "Shooting fotografico",
          "Ottimizzazione degli annunci",
          "Localizzazione dei contenuti",
          "Revisione delle impostazioni commerciali pertinenti",
        ],
        excluded: [],
      },
    ],
  },
  en: {
    kicker: "OGStay Services",
    title: "Our experience. At your home's service.",
    sub: "You don't have to hand us the whole management to work with us. Choose the professional support that can make the difference for your property.",
    launchNote: "Launch offer reserved for the first 5 clients of each participating service.",
    launchSub: "Indicative 30% discount, with commercially rounded prices.",
    listino: "List price",
    lancio: "Launch",
    quote: "On quotation",
    discover: "See what's included",
    close: "Close details",
    request: "Request information",
    includedLabel: "What's included",
    excludedLabel: "Not included",
    timingLabel: "Indicative timing",
    conditionsLabel: "Conditions",
    remoteBadge: "Available remotely",
    onsiteBadge: "On-site presence",
    whatsapp: "Message us on WhatsApp",
    call: "Call us",
    callCta: "Let's talk: 15 free minutes.",
    callCtaSub: "A no-obligation introductory call, scheduled together.",
    waMessage: (service) => `Hello OGStay, I'm interested in the ${service} service. I'd like more information and a free introductory call.`,
    services: [
      {
        id: "ottimizzazione-annunci",
        icon: "Megaphone",
        title: "Airbnb & Booking.com Listing Optimisation",
        tagline: "Your listing is your first salesperson. We make it more effective.",
        description: "We review your listing top to bottom: copy, photos, amenities and commercial settings, making it clearer, more convincing and more visible.",
        price: "€149",
        launch: "€104",
        remote: true,
        timing: "48–72 working hours from receiving all required materials.",
        conditions: "Price refers to one property and one platform.",
        included: [
          "Analysis of an existing listing",
          "Title and description optimisation",
          "Strategic reordering of available photos",
          "Content localisation in Italian, English, French, German and Spanish, where supported",
          "Review of amenities, features and characteristics",
          "Check of promotions and discounts",
          "Implementation of authorised changes",
          "Final summary",
        ],
        excluded: ["Photo shoot", "Revenue management", "Ongoing management"],
      },
      {
        id: "check-up-annuncio",
        icon: "FileSearch",
        title: "Listing Check-up",
        tagline: "Find out what you can improve, before investing.",
        description: "A fast, professional review of your listing, with a concrete report on intervention priorities.",
        price: "€49",
        launch: "€34",
        remote: true,
        timing: "48 working hours.",
        included: [
          "Analysis of one listing",
          "Review of title, copy and images",
          "Information check",
          "Identification of critical issues",
          "Report with five priority actions",
        ],
        excluded: ["Direct changes to the listing"],
      },
      {
        id: "pratiche-adempimenti",
        icon: "FileText",
        title: "Paperwork & Compliance",
        tagline: "Less bureaucracy. Faster to get started.",
        description: "We help you navigate procedures and requirements thanks to our operational experience and knowledge of sector practices.",
        price: "from €199",
        launch: "from €139",
        remote: true,
        timing: "Timing depends on the authorities and on how complete your documentation is.",
        conditions: "Reserved professional services are not included.",
        included: [
          "Preliminary check of applicable procedures",
          "Support for identification codes",
          "Assistance with Alloggiati Web procedures",
          "Guidance on statistical filings and tourist tax",
          "Document organisation",
          "Start-up checklist",
        ],
        excluded: [],
      },
      {
        id: "consulenza-1to1",
        icon: "MessagesSquare",
        title: "1:1 Strategy Consultation",
        tagline: "One hour together. A plan to improve.",
        description: "One hour focused on your business: we review listings, pricing and organisation together and you leave with a clear action plan.",
        price: "€99",
        launch: "€69",
        remote: true,
        timing: "60-minute video call, scheduled together.",
        conditions: "This paid consultation is separate from the free 15-minute introductory call.",
        included: [
          "Individual 60-minute video call",
          "Preliminary analysis of your needs",
          "Discussion on listings, pricing, organisation and management",
          "Personalised recommendations",
          "Summary of recommended actions",
        ],
        excluded: [],
      },
      {
        id: "revenue-management",
        icon: "TrendingUp",
        title: "Revenue Management",
        tagline: "The right price is not always the same.",
        description: "Two ways to work on pricing: an initial strategic setup, or ongoing rate management with a dedicated revenue manager.",
        remote: true,
        offers: [
          {
            name: "One-off Pricing Strategy",
            price: "€249",
            launch: "€174",
            included: [
              "Market and competition analysis",
              "Seasonality assessment",
              "Strategic price setting",
              "Guidance on minimum stays and restrictions",
              "Initial rate plan",
            ],
            excluded: ["Ongoing updates"],
          },
          {
            name: "Ongoing Revenue Management",
            price: "from €60/month per property",
            launch: null,
            launchNote: "The launch discount does not apply to the monthly fee.",
            included: [
              "Ongoing pricing strategy",
              "Periodic demand monitoring",
              "Price updates",
              "Booking trend analysis",
              "Dedicated revenue manager support",
            ],
            excluded: [],
          },
        ],
        conditions: "Ongoing-plan inclusions are defined according to the agreed plan.",
      },
      {
        id: "avvio-da-zero",
        icon: "KeyRound",
        title: "Holiday Home Start-up from Scratch",
        tagline: "From the idea to your first listing.",
        description: "We guide you step by step through the birth of your business: from preparing the home to your first online listing.",
        price: "from €399",
        launch: "from €279",
        remote: true,
        timing: "To be agreed based on your starting point.",
        conditions: "Exclusions apply unless otherwise agreed.",
        included: [
          "Initial assessment",
          "Preparation checklist",
          "Advice on amenities and organisation",
          "Initial setup of the agreed accounts",
          "Creation of one listing",
          "Basic operational settings",
          "Guidance on guest communication",
          "Initial training",
        ],
        excluded: ["Administrative paperwork", "Photo shoot", "Paid software", "Advanced revenue management"],
      },
      {
        id: "audit-completo",
        icon: "ClipboardCheck",
        title: "Full Business Audit",
        tagline: "Find out where you're losing opportunities.",
        description: "A complete analysis of your short-let business, with a report showing where to act first.",
        price: "from €299",
        launch: "from €209",
        remote: true,
        timing: "To be agreed based on available documentation.",
        included: [
          "Listing analysis",
          "Sales channel analysis",
          "Guest communication review",
          "Operational process review",
          "Analysis of available data",
          "Report with intervention priorities",
        ],
        excluded: ["Implementation of the changes"],
      },
      {
        id: "home-staging",
        icon: "Sparkles",
        title: "Home Staging for Holiday Homes",
        tagline: "We don't just furnish rooms. We make them more desirable.",
        description: "We enhance your home with targeted interventions, designed for listings and guests, right through to preparing it for the photo shoot.",
        quote: true,
        remote: false,
        timing: "Defined after the site visit and proposal.",
        conditions: "OGStay's fee and the cost of materials are separate. Items purchased for the client remain the client's property. Transport, assembly or special works are quoted separately.",
        included: [
          "Property analysis",
          "Aesthetic enhancement proposal",
          "Intervention plan",
          "Budget definition",
          "Selection of furnishings, textiles and decorations",
          "Purchase of owner-approved materials",
          "Room styling",
          "Preparing the home for the photo shoot",
        ],
        excluded: [],
      },
      {
        id: "fotografia",
        icon: "Camera",
        title: "Professional Photography",
        tagline: "The right images make people see your home differently.",
        description: "A photo shoot designed for short lets: rooms, details and strengths, with images ready for your listings.",
        quote: true,
        remote: false,
        timing: "To be agreed based on property availability.",
        conditions: "The quote specifies the number of shots, travel and usage rights.",
        included: [
          "Shoot planning",
          "Photographers specialised in holiday homes",
          "Photography of rooms and key strengths",
          "Selection and post-production",
          "Image delivery",
          "Guidance for use in listings",
        ],
        excluded: [],
      },
      {
        id: "listing-makeover",
        icon: "Palette",
        title: "OGStay Listing Makeover",
        tagline: "The complete transformation of your online presence.",
        description: "The integrated package: room styling, professional images and listings rewritten from scratch, to relaunch with a completely new online presence.",
        quote: true,
        remote: false,
        timing: "Defined according to the agreed interventions.",
        conditions: "Materials and extra services to be quoted separately. Revenue Management available as an add-on service.",
        included: [
          "Property assessment",
          "Home staging",
          "Photo shoot",
          "Listing optimisation",
          "Content localisation",
          "Review of relevant commercial settings",
        ],
        excluded: [],
      },
    ],
  },
};

export const PATHS = {
  it: {
    title: "Come possiamo aiutarti?",
    a: {
      title: "Vuoi delegare la gestione della tua casa vacanza?",
      sub: "Un team locale che coordina strategia, ospiti, operatività e risultati. Presenza operativa reale in Ogliastra.",
      cta: "Scopri le soluzioni di gestione",
    },
    b: {
      title: "Vuoi continuare a gestire la tua casa, ma con il supporto di professionisti?",
      sub: "Annunci, prezzi, fotografia, home staging, adempimenti e consulenza: scegli soltanto ciò che ti serve. Molti servizi anche da remoto, in tutta Italia.",
      cta: "Esplora OGStay Services",
    },
  },
  en: {
    title: "How can we help you?",
    a: {
      title: "Do you want to delegate the management of your holiday home?",
      sub: "A local team coordinating strategy, guests, operations and results. Real on-the-ground presence in Ogliastra.",
      cta: "Discover our management solutions",
    },
    b: {
      title: "Do you want to keep managing your home, but with professional support?",
      sub: "Listings, pricing, photography, home staging, compliance and consulting: choose only what you need. Many services available remotely, across Italy.",
      cta: "Explore OGStay Services",
    },
  },
};

export const SERVICE_FORM = {
  it: {
    title: "Richiedi informazioni",
    sub: "Raccontaci cosa ti serve: ti rispondiamo entro 24 ore.",
    name: "Nome",
    namePh: "Il tuo nome",
    email: "Email",
    emailPh: "nome@email.it",
    phone: "Telefono",
    phonePh: "+39 …",
    service: "Servizio di interesse",
    other: "Altro / non so ancora",
    message: "Messaggio (facoltativo)",
    messagePh: "Raccontaci la tua situazione…",
    consent: "Ho letto la Privacy Policy e acconsento al trattamento dei dati per essere ricontattato.",
    submit: "Invia la richiesta",
    sending: "Invio in corso…",
    successTitle: "Richiesta inviata.",
    successBody: "Grazie! Ti risponderemo entro 24 ore con tutte le informazioni sul servizio.",
    success: "Richiesta inviata. Ti risponderemo entro 24 ore.",
    error: "Qualcosa non ha funzionato. Riprova tra poco.",
    required: "Campo obbligatorio",
    emailError: "Inserisci un'email valida",
    consentError: "Serve il consenso privacy per continuare",
  },
  en: {
    title: "Request information",
    sub: "Tell us what you need: we'll reply within 24 hours.",
    name: "Name",
    namePh: "Your name",
    email: "Email",
    emailPh: "name@email.com",
    phone: "Phone",
    phonePh: "+39 …",
    service: "Service of interest",
    other: "Other / not sure yet",
    message: "Message (optional)",
    messagePh: "Tell us about your situation…",
    consent: "I have read the Privacy Policy and consent to my data being processed so I can be contacted.",
    submit: "Send request",
    sending: "Sending…",
    successTitle: "Request sent.",
    successBody: "Thank you! We'll reply within 24 hours with all the details about the service.",
    success: "Request sent. We'll reply within 24 hours.",
    error: "Something went wrong. Please try again shortly.",
    required: "Required field",
    emailError: "Enter a valid email",
    consentError: "Privacy consent is required to continue",
  },
};


// Ordine commerciale delle schede servizio (priorità commerciale e facilità di comprensione)
export const SERVICE_ORDER = [
  "ottimizzazione-annunci",
  "revenue-management",
  "home-staging",
  "fotografia",
  "listing-makeover",
  "avvio-da-zero",
  "pratiche-adempimenti",
  "consulenza-1to1",
  "check-up-annuncio",
  "audit-completo",
];

// Contatto finale semplificato — chiamata conoscitiva gratuita 15 minuti
export const CONTACT = {
  it: {
    whatsapp: "Scrivici su WhatsApp",
    call: "Chiamaci",
    orForm: "oppure lascia i tuoi dati: ti richiamiamo noi",
    waMessage: (topic) =>
      `Buongiorno OGStay, vorrei ricevere informazioni${topic ? ` su ${topic}` : ""} e organizzare una chiamata conoscitiva gratuita di 15 minuti.`,
    name: "Nome",
    namePh: "Il tuo nome",
    phone: "Telefono",
    phonePh: "+39 …",
    email: "Email (facoltativa se lasci il telefono)",
    emailPh: "nome@email.it",
    interest: "Cosa ti interessa?",
    interests: ["Gestione Completa", "Gestione Online", "Su Misura · Villas", "Servizio singolo"],
    singleService: "Servizio singolo",
    service: "Quale servizio?",
    location: "Località dell'immobile (facoltativo)",
    locationPh: "Tortolì, Arbatax…",
    message: "Messaggio (facoltativo)",
    messagePh: "Raccontaci la tua situazione…",
    consent: "Ho letto la Privacy Policy e acconsento al trattamento dei dati per essere ricontattato.",
    submit: "Richiedi la chiamata gratuita",
    sending: "Invio in corso…",
    successTitle: "Richiesta ricevuta.",
    successBody: "Ti ricontattiamo entro 24 ore per fissare la tua chiamata conoscitiva gratuita di 15 minuti.",
    success: "Richiesta inviata. Ti ricontattiamo entro 24 ore.",
    error: "Qualcosa non ha funzionato. Riprova tra poco.",
    required: "Campo obbligatorio",
    contactError: "Lascia almeno un recapito: telefono o email",
    emailError: "Inserisci un'email valida",
    consentError: "Serve il consenso privacy per continuare",
    detailedTitle: "Vuoi già darci tutti i dettagli?",
    detailedSub: "Se pensi alla gestione completa, puoi compilare subito la valutazione dettagliata: ci aiuta a preparare un'analisi più precisa.",
    detailedCta: "Compila la valutazione dettagliata",
    detailedClose: "Chiudi il modulo dettagliato",
  },
  en: {
    whatsapp: "Message us on WhatsApp",
    call: "Call us",
    orForm: "or leave your details: we'll call you back",
    waMessage: (topic) =>
      `Hello OGStay, I'd like information${topic ? ` about ${topic}` : ""} and to arrange a free 15-minute introductory call.`,
    name: "Name",
    namePh: "Your name",
    phone: "Phone",
    phonePh: "+39 …",
    email: "Email (optional if you leave your phone)",
    emailPh: "name@email.com",
    interest: "What are you interested in?",
    interests: ["Full Management", "Online Management", "Tailor-made · Villas", "Single service"],
    singleService: "Single service",
    service: "Which service?",
    location: "Property location (optional)",
    locationPh: "Tortolì, Arbatax…",
    message: "Message (optional)",
    messagePh: "Tell us about your situation…",
    consent: "I have read the Privacy Policy and consent to my data being processed so I can be contacted.",
    submit: "Request the free call",
    sending: "Sending…",
    successTitle: "Request received.",
    successBody: "We'll get back to you within 24 hours to schedule your free 15-minute introductory call.",
    success: "Request sent. We'll get back to you within 24 hours.",
    error: "Something went wrong. Please try again shortly.",
    required: "Required field",
    contactError: "Leave at least one contact: phone or email",
    emailError: "Enter a valid email",
    consentError: "Privacy consent is required to continue",
    detailedTitle: "Want to give us all the details already?",
    detailedSub: "If you're thinking about full management, you can fill in the detailed valuation now: it helps us prepare a more precise analysis.",
    detailedCta: "Fill in the detailed valuation",
    detailedClose: "Close the detailed form",
  },
};